import {Form} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

export type ClearSelectionEvent = () => void

interface ClearSelectionProps {
    clearSelectionEvent : ClearSelectionEvent
    checked? : boolean
}

export const ClearSelection = ({clearSelectionEvent, checked} : ClearSelectionProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    function fireClearSelectionEvent()
    {
        if (clearSelectionEvent !== undefined) {
            clearSelectionEvent();
        }
    }

    return (
        <span className={"clear-selection btn btn-link p-0 align-bottom"} title={t("common.clear-selection")}>
            <Form.Check type="checkbox" checked={checked} onClick={fireClearSelectionEvent} readOnly/>
        </span>
    )
}
